const languages = [
  { value: 'en-US', label: 'en-US' },
  { value: 'pt-BR', label: 'pt-BR' },
];

export default languages;
